/* eslint-disable import/no-internal-modules */
import { t } from '@insided/deprecated-libs/translationsUtils/translations'
import { ckeditorEmojiUrl } from '@insided/deprecated-libs/constants'

export const toEditorFormat = (content: string) => {
  if (!content) return content

  content = content.replace(/\s<user-mention/gm, '&nbsp;<user-mention')

  const el = document.createElement('div')
  el.innerHTML = content

  const BBCodeCodeBlocks = el.querySelectorAll('.threadCode')
  BBCodeCodeBlocks.forEach((BBCodeCodeBlock) => {
    const oldCode = BBCodeCodeBlock.getElementsByTagName('pre')[0]
    const newCode = document.createElement('code')
    newCode.innerHTML = oldCode.innerHTML
    oldCode.innerHTML = newCode.outerHTML
    BBCodeCodeBlock.replaceWith(newCode)
  })

  const codeBlocks = el.querySelectorAll('code')
  codeBlocks.forEach((codeBlock) => {
    codeBlock.innerHTML = codeBlock.innerHTML.replace(/(<br>)/gm, '\n')
  })

  const callouts = el.querySelectorAll('.callout')
  callouts.forEach((callout) => {
    const wrapper = document.createElement('div')
    wrapper.innerHTML = callout.innerHTML
    callout.innerHTML = wrapper.outerHTML
  })

  const spoilerContainersConverted = el.querySelectorAll('content-spoiler')

  if (spoilerContainersConverted.length) {
    spoilerContainersConverted.forEach(spoilerContainerConverted => {
      const spoilerContainer = document.createElement('div')
      spoilerContainer.classList.add('spoiler-container')

      spoilerContainer.innerHTML = `<div class='hideBtn'>Hide content</div><div class='content-spoiler'>${spoilerContainerConverted.innerHTML}</div>`
      spoilerContainerConverted.replaceWith(spoilerContainer)
    })
  }

  const quotes = el.querySelectorAll('content-quote')
  quotes.forEach((quote) => {
    const quotedUser = document.createElement('div')
    quotedUser.className = 'content-quote-username'
    quotedUser.textContent = `${quote.getAttribute('data-username')} ${t('Common', 'wrote')}:`

    const quotedContent = document.createElement('div')
    quotedContent.className = 'content-quote-content'

    while (quote.childNodes.length > 0) {
      quotedContent.appendChild(quote.childNodes[0])
    }
    quote.appendChild(quotedUser)
    quote.appendChild(quotedContent)
  })

  el.querySelectorAll('figcaption').forEach(caption => {
    if (!caption.parentElement || caption.parentElement.tagName.toLowerCase() === 'figure') return
    const paragraph = document.createElement('p')
    paragraph.innerHTML = caption.innerHTML
    caption.replaceWith(paragraph)
  })

  const emojies = el.querySelectorAll(`img[src^="${ckeditorEmojiUrl}"]`)
  emojies.forEach((emoji) => {
    const unicode = emoji.getAttribute('alt')
    emoji.replaceWith(unicode ?? '')
  })

  return el.innerHTML
}

export const fromEditorFormat = (content: string) => {
  if (!content) return content

  const el = document.createElement('div')
  el.innerHTML = content
  const embeds = el.querySelectorAll('[data-oembed-url]')
  embeds.forEach(embed => {
    const embedNode = document.createElement('oembed')
    embedNode.setAttribute('url', embed.getAttribute('data-oembed-url') ?? '')
    embed.replaceWith(embedNode)
  })

  let codeBlocks = el.querySelectorAll('code')
  const store: HTMLElement[] = []
  codeBlocks.forEach(codeBlock => {
    store.push(codeBlock)
  })

  codeBlocks = el.querySelectorAll('code')

  codeBlocks.forEach((codeBlock, index) => {
    store[index].innerHTML = store[index].innerHTML.replace(/(\r\n|\n|\r)/gm, '<br>')
    codeBlock.replaceWith(store[index])
  })

  const spoilerContainers = el.querySelectorAll('.spoiler-container')
  const contentSpoilers = el.querySelectorAll('.content-spoiler')

  if (spoilerContainers.length) {
    spoilerContainers.forEach((spoilerContainer, i) => {
      const spoilerEl = document.createElement('content-spoiler')
      spoilerEl.innerHTML = contentSpoilers[i].innerHTML
      spoilerContainer.before(spoilerEl)
      spoilerContainer.remove()
    })
  }

  const figureCaptions = el.querySelectorAll('figcaption')
  figureCaptions.forEach(caption => {
    if (!(caption.textContent ?? '').trim()) {
      caption.remove()
    }
  })

  const quoteUsers = el.querySelectorAll('.content-quote-username')
  quoteUsers.forEach(quote => {
    quote.remove()
  })
  return el.innerHTML
}
